//angular imports
import { ChangeDetectionStrategy, Component, signal, WritableSignal } from '@angular/core';

//local imports
import { DocumentModel, RoomHttpService } from '@app/catalog';
import { ToastLevel, ToastMessage } from '@app/components';
import { UnhandledErrorMessage } from '@app/app-common';
import { Messenger, PresenterType } from '@app/shared';


@PresenterType({
  model: DocumentModel,
  key: "tileBottom",
})
@Component({
  selector: 'document-carousel-item-bottom',
  standalone: false,
  templateUrl: './document-carousel-item-bottom.component.html',
  styleUrl: './document-carousel-item-bottom.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentCarouselItemBottomComponent {

  public data: WritableSignal<DocumentModel> = signal<DocumentModel>(undefined);
  public isLoading: WritableSignal<boolean> = signal<boolean>(false);

  constructor(
    private roomHttpService: RoomHttpService,
    private messenger: Messenger
  ) {}


  public async downloadDoc() {
    const doc = this.data();
    this.isLoading.set(true);
    try {
          const documentResult = this.roomHttpService.downloadDocument(doc.id);
          const data = await documentResult.response;
          const link = document.createElement('a');
          link.href = data.url;
          link.download = doc.name();
          link.target = '_blank';
          link.click();
        } catch (error) {
        this.messenger.send(ToastMessage.create(new UnhandledErrorMessage(),ToastLevel.Warning));
        } finally {
          this.isLoading.set(false);
        }
    }
}
